<template>
    <div class="main-bg">
        <router-view style="position:relative;z-index:1;"></router-view>
    </div>
</template>

<script>
// import store from '@/store/index'
export default {
    name: 'main-bg',
    data () {
        return {
        }
    },
    components: {
    },
    computed: {
    },
    // beforeRouteEnter (to, from, next) {
    //     // 验证用户登录
    //     store.dispatch('getUserInfo')
    //         .then(() => {
    //             next(vm => {
    //                 if (store.state.user.range.rangeId) {

    //                 } else {
    //                     let host = location.host
    //                     let protocol = location.protocol
    //                     location.href = protocol + '//' + host + '/'
    //                 }
    //             })
    //         })
    //         .catch(() => {
    //             next()
    //         })
    //     // }
    // },
    created () {
    },
    methods: {
    }

}
</script>

<style scoped>
.main-bg{
    width: 100%;
    min-height: 100%;
    /* background: url('../assets/img/bg.png') no-repeat center bottom; */
    background-size: 100% auto;
    background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue